<div>
  <div mat-table>
    <div class="list-item-skeleton">
      <div mat-row>
        <div mat-cell class="fixIE11verticallyCentered">
          <skeleton-item style="width: 170px"></skeleton-item>
        </div>
      </div>
      <div mat-row>
        <div mat-cell class="fixIE11verticallyCentered">
          <skeleton-item style="width: 200px"></skeleton-item>
        </div>
      </div>
    </div>
    <div class="list-item-skeleton">
      <div mat-row>
        <div mat-cell class="fixIE11verticallyCentered">
          <skeleton-item style="width: 40px"></skeleton-item>
        </div>
      </div>
      <div mat-row>
        <div mat-cell class="fixIE11verticallyCentered">
          <skeleton-item style="width: 70px"></skeleton-item>
        </div>
      </div>
    </div>
    <div class="list-item-skeleton">
      <div mat-row>
        <div mat-cell class="fixIE11verticallyCentered">
          <skeleton-item style="width: 80px"></skeleton-item>
        </div>
      </div>
      <div mat-row>
        <div mat-cell class="fixIE11verticallyCentered">
          <skeleton-item style="width: 100px"></skeleton-item>
        </div>
      </div>
    </div>
    <div class="list-item-skeleton">
      <div mat-row>
        <div mat-cell class="fixIE11verticallyCentered">
          <skeleton-item style="width: 80px"></skeleton-item>
        </div>
      </div>
      <div mat-row>
        <div mat-cell class="fixIE11verticallyCentered">
          <skeleton-item style="width: 90px"></skeleton-item>
        </div>
      </div>
    </div>
    <div class="list-item-skeleton">
      <div mat-row>
        <div mat-cell class="fixIE11verticallyCentered">
          <skeleton-item style="width: 100px"></skeleton-item>
        </div>
      </div>
      <div mat-row>
        <div mat-cell class="fixIE11verticallyCentered">
          <skeleton-item style="width: 130px"></skeleton-item>
        </div>
      </div>
    </div>
    <div class="list-item-skeleton">
      <div mat-row>
        <div mat-cell class="fixIE11verticallyCentered">
          <skeleton-item style="width: 140px"></skeleton-item>
        </div>
      </div>
      <div mat-row>
        <div mat-cell class="fixIE11verticallyCentered">
          <skeleton-item style="width: 50px"></skeleton-item>
        </div>
      </div>
    </div>
  </div>
</div>
